export default "__VITE_ASSET__C$mhunVt__"